/* Dodawanie propozycji z koszyka bez przeładowania strony.
   Po dodaniu prosimy Shopify o świeży HTML sekcji koszyka i podmieniamy go,
   dzięki czemu pasek darmowej dostawy i lista propozycji same się aktualizują. */
(() => {
  const naStronieKoszyka = () => location.pathname.endsWith('/cart');

  const sekcjeDoOdswiezenia = () =>
    naStronieKoszyka()
      ? [['main-cart-items', '.js-contents'], ['main-cart-footer', '.js-contents']]
      : [['cart-drawer', '#CartDrawer'], ['cart-icon-bubble', '#cart-icon-bubble']];

  const wyciagnij = (html, selektor) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selektor);
    return el ? el.innerHTML : null;
  };

  const pokazBlad = (kontener, tekst) => {
    const p = kontener?.querySelector('.ciroa-up__error');
    if (!p) return;
    p.textContent = tekst;
    p.hidden = false;
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.ciroa-up__add');
    if (!btn) return;
    e.preventDefault();

    const kontener = btn.closest('[data-ciroa-upsell]');
    const wariant = btn.dataset.wariant;
    if (!wariant || btn.disabled) return;

    const etykieta = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Dodaję…';

    const sekcje = sekcjeDoOdswiezenia();
    try {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(wariant), quantity: 1 }],
          sections: sekcje.map(([id]) => id).join(','),
          sections_url: location.pathname,
        }),
      });
      const dane = await r.json();
      if (!r.ok) {
        pokazBlad(kontener, dane.description || 'Nie udało się dodać produktu.');
        btn.disabled = false;
        btn.textContent = etykieta;
        return;
      }
      sekcje.forEach(([id, selektor]) => {
        const html = dane.sections?.[id];
        if (!html) return;
        const cel = document.querySelector(selektor);
        const nowa = wyciagnij(html, selektor);
        if (cel && nowa !== null) cel.innerHTML = nowa;
      });
      // szuflada mogła być zamknięta - otwieramy, żeby było widać efekt
      const szuflada = document.querySelector('cart-drawer');
      if (szuflada && !naStronieKoszyka()) {
        szuflada.classList.remove('is-empty');
        if (typeof szuflada.open === 'function') szuflada.open();
      }
      document.dispatchEvent(new CustomEvent('ciroa:cart-updated'));
    } catch (err) {
      pokazBlad(kontener, 'Coś poszło nie tak. Spróbuj ponownie.');
      btn.disabled = false;
      btn.textContent = etykieta;
    }
  });
})();
